module.exports = __webpack_public_path__ + "static/bronze-ea44c2d279017a475c9ed089dc0fba1a.svg";